import { useEffect } from "react"
import { useNavigate } from "react-router-dom"
import { useAppDispatch, useAppSelector } from "../../../../lib/redux/hooks"
import { colors } from "../../../../ui/colors"
import { ArrowLeftIcon } from "../../../../ui/icons/arrow-left"
import { Layout } from "../../../../ui/layout"
import { ButtonComponent } from "../../../../ui/molecules/button/newButton"
import { MenuItems } from "../../../../ui/organisms/navbar/dto"
import { TrainingPopupAdd } from "../popup/add"
import { GetAllTraining, resetTrainingCreationRequest, resetTrainingCreationStatus, resetTrainings, resetTrainingValidationStatus, TrainingCreation, TrainingValidation } from "../slice"

export function NewTraining() {
    const dispatch = useAppDispatch()
    const trainingState = useAppSelector(state => state.PMTraining)
    const navigate = useNavigate()

    useEffect(() => {
        if (trainingState.trainingValidationStatus === 'successfully') {
            dispatch(resetTrainingValidationStatus())
            dispatch(TrainingCreation(trainingState.trainingCreationRequest))
        }
    }, [trainingState.trainingValidationStatus])

    useEffect(() => {
        if (trainingState.trainingCreationStatus === 'successfully') {
            dispatch(resetTrainingCreationRequest())
            dispatch(resetTrainingCreationStatus())
            dispatch(resetTrainings())
            dispatch(GetAllTraining(trainingState.getAllTrainingFilters))
            navigate('/formazione')
        }
    }, [trainingState.trainingCreationStatus])

    return (
        <Layout
            menuItem={MenuItems.GESTIONE_PERSONALE}
            breadcrumbItems={['Formazione dipendenti', 'Formazione', 'Nuova Formazione']}
            headerLabel="Nuova Formazione"
            rightBar={true}
            headerIcon={
                <ArrowLeftIcon onClick={() => navigate('/formazione')} color={colors.brandPrimary[50]} size={0} />
            }
            headerChildren={
                <div className="flex items-center h-full w-full justify-end">
                    <ButtonComponent
                        size="sm"
                        iconPosition="off"
                        variant="solid"
                        label="Salva"
                        color="orange"
                        onClick={() => dispatch(TrainingValidation(trainingState.trainingCreationRequest))}
                    />
                </div>
            }
        >
            <div>
                <TrainingPopupAdd />
            </div>
        </Layout>
    )
}